import { render, staticRenderFns } from "./audioRecorder.vue?vue&type=template&id=28e256da&scoped=true&"
import script from "./audioRecorder.vue?vue&type=script&lang=js&"
export * from "./audioRecorder.vue?vue&type=script&lang=js&"
import style0 from "./audioRecorder.vue?vue&type=style&index=0&id=28e256da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e256da",
  null
  
)

export default component.exports